<template>
    <section class="api-element api-element-resource" :id="`resource-${resource.slug}`">
        <header class="resource-header">
            <h2 class="resource-name">{{ resource.name }}</h2>
        </header>
        <article class="resource-endpoints">
            <api-endpoint v-for="endpoint in endpoints" :key="endpoint.id" :endpoint="endpoint"/>
        </article>
    </section>
</template>

<!--suppress JSValidateTypes -->
<script>
  import ApiEndpoint from './ApiEndpoint';

  export default {
    name:       'ApiResource',
    components: { ApiEndpoint },

    props: {

      /**
       * @var {Resource}
       */
      resource: {
        type:     Object,
        required: true,
      },
    },

    computed: {
      endpoints () {
        return this.resource.endpoints;
      },
    },
  };
</script>

<style scoped>
    .api-element-resource {
        padding-top: 1rem;
    }

    .api-element-resource + .api-element-resource {
        margin-top: 3rem;
    }

    .resource-name {
        margin:    0;
        font-size: 1.8rem;
    }

    .resource-endpoints {
        margin-top: 1rem;
    }
</style>
